module.exports = __webpack_public_path__ + "img/printer.5295d51b.svg";